<template>
    <b-row align-h="center">
        <b-col>
            <div v-if="categories.length > 0" class="slider">
                <pb-carousel>
                    <pb-carousel-item style="width: 275px;" class="my-3 card-deck category-card-deck"
                                      :key="category.id"
                                      v-for="(category) in categories">
                        <router-link :to="{name: 'category', params: {id: category.id}}"
                                     class="card slider-card border-0 m-0 p-0 category-card cursor-pointer">
                            <div class="card-body p-0">
                                <img class="card-img-top" :src="fileResourceUrl(category.image)"
                                     alt="Card image cap"/>
                            </div>
                            <div class="card-footer">
                                <p class="card-text">{{category.webName}}</p>
                            </div>
                        </router-link>
                    </pb-carousel-item>
                </pb-carousel>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    export default {
        name: 'pb-category-slider',
        props: {
            categories: {
                type: Array
            }
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .tns-ovh {
        padding: 20px 0 !important;
    }

    .category-card-deck {
        height: 275px;

        .slider-card {
            width: 275px;
            height: 275px;

            img.card-img-top {
                object-fit: contain;
                height: 100%;
            }
        }
    }
</style>